module.exports = __webpack_public_path__ + "img/Tauchtrupp.4b025940.svg";